import { createContext, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

// The AuthProvider component wraps the app and provides
// authentication-related state and functions to all
// components through the useAuth hook.
export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  // Logs in the given user, sets isLoggedIn to true, sets the user
  // state to the given user, and navigates to the user dashboard.
  const login = (user) => {
    setIsLoggedIn(true);
    setUser(user);
    navigate("/userdashboard");
  };

  //   Logs out the current user by setting isLoggedIn to false and navigating to the root route.
  const logout = () => {
    setIsLoggedIn(false);
    navigate("/");
  };

  const value = {
    isLoggedIn,
    login,
    logout,
    user,
    setUser,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
